const s = {
  name: "Yubikey",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M14,13.3l2.2-2.9l1.6,1.2l-5,6.5l-1.6-1.2l1.5-2l-2.5-3.3l1.6-1.2L14,13.3z"/>
		<path class="st0" d="M14,5c-5,0-9,4-9,9c0,5,4,9,9,9c5,0,9-4,9-9C23,9,19,5,14,5z M7,14c0-3.9,3.1-7,7-7s7,3.1,7,7s-3.1,7-7,7
			S7,17.9,7,14z"/>
		<path class="st0" d="M13,35v-5h2v5H13z"/>
		<path class="st0" d="M17,30v6h2v-6H17z"/>
		<path class="st0" d="M9,36v-6h2v6H9z"/>
		<path class="st0" d="M5,28H3c-1.7,0-3-1.3-3-3V3c0-1.7,1.3-3,3-3h22c1.7,0,3,1.3,3,3v22c0,1.7-1.3,3-3,3h-2v12H5V28z M2,3v22
			c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1V3c0-0.6-0.4-1-1-1H3C2.4,2,2,2.4,2,3z M7,28v10h14V28H7z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Yubikey
};
